/**
 * Lựa chọn dùng chung của màn banner (bảng + form).
 *
 * PHẢI khớp whitelist bên BE: `Banner::AUDIENCES` và `Banner::TARGETS`
 * (loyaltysmart_be/Modules/ServiceConnect/Models/Banner.php). BE validate bằng
 * `Rule::in`, nên thêm lựa chọn ở đây mà quên thêm bên đó thì lưu trả 400.
 */

/**
 * Đối tượng thấy banner. UI chỉ ba lựa chọn: NPP đi chung nhánh Đại lý
 * (`Customer::allowedPromotionAudiences` cho NPP thấy cả banner DEALER), nên không
 * cần bắt người vận hành phân biệt thêm một mức nữa.
 */
export const AUDIENCE_OPTIONS = [
  { value: "ALL", label: "Tất cả" },
  { value: "CONTRACTOR", label: "Thợ thầu" },
  { value: "DEALER", label: "Đại lý & NPP" },
];

export const AUDIENCE_LABEL = {
  ALL: "Tất cả",
  CONTRACTOR: "Thợ thầu",
  DEALER: "Đại lý & NPP",
  NPP: "NPP",
};

/*
 * Điểm đến khi bấm banner: lưu ĐUÔI route, BE ghép prefix `/contractor` hoặc `/dealer`
 * theo vai của người đang xem. Vì vậy một banner "Tất cả" chỉ được chọn điểm đến CÓ Ở
 * CẢ HAI nhánh — quét mã (chỉ Thợ thầu) và đơn hàng (chỉ Đại lý) không nằm trong đó.
 */
const TARGET_COMMON = [
  { value: "/products", label: "Sản phẩm tham gia" },
  { value: "/rewards", label: "Đổi quà" },
  { value: "/my-rewards", label: "Quà của tôi" },
  { value: "/history", label: "Lịch sử điểm" },
  { value: "/tier", label: "Hạng thành viên" },
  { value: "/news", label: "Tin tức" },
];

const TARGET_CONTRACTOR = { value: "/scan", label: "Quét mã tích điểm" };
const TARGET_DEALER = { value: "/orders", label: "Đơn hàng" };

/** Điểm đến hợp lệ theo đối tượng đang chọn. */
export function targetOptions(audience) {
  if (audience === "CONTRACTOR") return [...TARGET_COMMON, TARGET_CONTRACTOR];
  if (audience === "DEALER" || audience === "NPP") return [...TARGET_COMMON, TARGET_DEALER];
  return TARGET_COMMON;
}

export const TARGET_LABEL = [...TARGET_COMMON, TARGET_CONTRACTOR, TARGET_DEALER].reduce(
  (acc, item) => ({ ...acc, [item.value]: item.label }),
  {}
);

/**
 * Khung ảnh banner: 1080 × 540 (2:1) — đúng tỉ lệ mặc định của `BannerCarousel` bên
 * mini app. Ảnh lệch tỉ lệ vẫn lưu được nhưng bị `object-cover` cắt hai đầu, nên form
 * cảnh báo trước khi lưu.
 */
export const BANNER_RATIO = 2;
export const BANNER_RATIO_TOLERANCE = 0.05; // lệch quá 5% thì nhắc
export const BANNER_SIZE_HINT = "1080 × 540 px (tỉ lệ 2:1), < 2MB";
